import styled from 'styled-components';
import { Flexbox } from '@hiiretail/synergy-ui';

export const ResetUserPasswordFormWrapper = styled(Flexbox)`
  padding: ${({ theme }) => theme.spacing(4)}px;
  background: #fff;
  border-radius: 4px;
`;
